import helper from '@/libs/forms';
import LIABILITY_TYPE_MAP from '@/components/profile/sections/tabs/financial/resources/contingentTypesMap';


const options = Object.keys(LIABILITY_TYPE_MAP).map(
  key => ({ id: key, name: LIABILITY_TYPE_MAP[key] }),
);


export default {
  fields: [
    helper.simpleSelect('Type', 'type', true, options, null),
    helper.currency('Amount', 'amount', true),
  ],
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/liabilities/schemas/contingents.js